import React from 'react';

import { cn } from '@lyearn/style';
import { Stack } from '@lyearn/ui';
import RichTextViewer from '@/components/RichTextViewer';
import { PerformanceEvaluationStatusEnum } from '@/types/schema';

import { QuizPlayerAnswerFeedbackProps } from './types';

function QuestionAnswerFeedback(props: QuizPlayerAnswerFeedbackProps) {
  const {
    className,
    correctAnswerFeedback,
    incorrectAnswerFeedback,
    evaluationStatus,
    variant = 'body-long-02',
  } = props;

  if (!evaluationStatus) {
    return null;
  }

  const isCorrect = evaluationStatus === PerformanceEvaluationStatusEnum.Correct;
  const answerFeedback = isCorrect ? correctAnswerFeedback : incorrectAnswerFeedback;

  if (answerFeedback) {
    return (
      <Stack
        className={cn('w-full rounded-8 bg-bg-secondary p-16 pt-12', className)}
        direction="col"
        gapY={8}>
        <RichTextViewer
          as="div"
          className="w-full"
          color="text-text-paragraph"
          html={answerFeedback ?? ''}
          variant={variant}
        />
      </Stack>
    );
  }

  return null;
}

export default QuestionAnswerFeedback;
